'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  ['\n  display: block;\n  max-width: 100%;\n  height: auto;\n'],
  ['\n  display: block;\n  max-width: 100%;\n  height: auto;\n']
)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Image = _Box2.default.withComponent('img').extend(_templateObject)

Image.displayName = 'Image'

exports.default = Image



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Image.js
// module id = 176
// module chunks = 168707334958949